<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Configure data stream</h1>

                    <a :href="`/#/admin/integrations/pipelines/details/${tid}/${id}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <span>Back</span>
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <h5>Available data streams</h5>
            <br />

            <div v-for="(ds, i) in dataStreams" class="form-group form-check">
                <input @click="handleChangeDataStreamCommandV1(ds)" type="radio" class="form-check-input" :id="`datastream${i}`" name="dataStream" :value="ds" :checked="dataStream === ds">
                <label class="form-check-label" :for="`datastream${i}`">{{ds}}</label>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineDataStreamPage, useAdminConfigurePipelinePropertiesPage } from '@Integrations/Pipelines/pages-core'

    document.title = "Configure data streams"

    const tid = useOrganizationUnitId()
    const id = useId()

    const connectorId = ref()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useConnectorDataStreamsQuery,
        useChangeDataStreamCommand,
    } = useAdminConfigurePipelineDataStreamPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const dataStream = computed<string>(() => modelPipelineDetailsQueryV1.value?.DataStream)

    const { runConnectorDataStreamsQueryV1, modelConnectorDataStreamsQueryV1 } = useConnectorDataStreamsQuery(connectorId)
    const dataStreams = computed<string[]>(() => modelConnectorDataStreamsQueryV1.value?.DataStreams || [])

    const { invokeChangeDataStreamCommandV1, succeedChangeDataStreamCommandV1 } = useChangeDataStreamCommand(id, tid, userId)

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
    })

    watch(connectorId, () => {
        runConnectorDataStreamsQueryV1()
    })

    watch(modelPipelineDetailsQueryV1, () => {
        connectorId.value = modelPipelineDetailsQueryV1.value.ConnectorId
    })

    watch(succeedChangeDataStreamCommandV1, () => succeedChangeDataStreamCommandV1.value && runPipelineDetailsQueryV1())

    function handleChangeDataStreamCommandV1(dataStream: string){
        invokeChangeDataStreamCommandV1({ DataStream: dataStream })
    }
</script>